var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
import debounce from '../../../../core/utils/src/debounce';
import CONSTANT from './constants';
var FilteringHandler = /** @class */ (function () {
    function FilteringHandler(select, enableKeypressWhenClosed) {
        var _this = this;
        if (enableKeypressWhenClosed === void 0) { enableKeypressWhenClosed = true; }
        this.select = select;
        this.enableKeypressWhenClosed = enableKeypressWhenClosed;
        this.filteringText = '';
        this.delayedResetKeypressBuffer = debounce(function () { return (_this.filteringText = ''); }, 500);
        this.delayedNotifyInput = debounce(function () { return _this.select.controller.notifyFilteringChange(); });
    }
    FilteringHandler.prototype.addListeners = function () {
        this.__createListeners();
        // We need to wrap the native events with our own
        this.select.node.addEventListener(CONSTANT.AWSUI_PREFIX + "input", this.filteringInputListener);
        this.select.node.addEventListener('keypress', this.keypressListener);
    };
    FilteringHandler.prototype.removeListeners = function () {
        this.select.node.removeEventListener(CONSTANT.AWSUI_PREFIX + "input", this.filteringInputListener);
        this.select.node.removeEventListener('keypress', this.keypressListener);
    };
    FilteringHandler.__isChar = function (charCode) {
        return [0, CONSTANT.ENTER, CONSTANT.SPACE, CONSTANT.TAB].indexOf(charCode) === -1;
    };
    FilteringHandler.__isRepeatedChar = function (str) {
        var repeatedChar = Array.prototype.reduce.call(str, function (a, b) {
            return a === b ? b : null;
        });
        return Boolean(repeatedChar);
    };
    FilteringHandler.prototype.__createListeners = function () {
        this.filteringInputListener = this.__filteringInput();
        this.keypressListener = this.__keypress();
    };
    FilteringHandler.prototype.__handleMatch = function (match) {
        if (this.select.__open) {
            this.select.__highlightedOption = match;
        }
        else {
            this.select.controller.selectOption(match);
        }
    };
    FilteringHandler.prototype.__match = function (strToFilter, text, strictMatching) {
        if (!strToFilter) {
            return false;
        }
        var matchIndex = strToFilter.toLowerCase().indexOf(text.toLowerCase());
        return strictMatching ? matchIndex === 0 : matchIndex !== -1;
    };
    FilteringHandler.prototype.__matchOption = function (option, text, strictMatching) {
        var _this = this;
        var tags = [];
        if (!strictMatching) {
            tags = tags.concat(option.filteringTags);
        }
        tags = tags.concat(option.tags);
        var tagsMatch = tags.some(function (tag) { return _this.__match(tag, text, strictMatching); });
        if (tagsMatch) {
            return tagsMatch;
        }
        return ['label', 'labelTag', 'description'].some(function (content) { return _this.__match(option[content], text, strictMatching); });
    };
    FilteringHandler.prototype.__findKeypressMatchingOptions = function (text) {
        var _this = this;
        return this.select.controller
            .getEnabledOptions(true)
            .filter(function (option) { return _this.__matchOption(option, text, true); });
    };
    FilteringHandler.prototype.__keypress = function () {
        var _this = this;
        return function (ev) {
            // Native search should not be active on closed dropdown if the flag says so
            if (!_this.enableKeypressWhenClosed && !_this.select.__open) {
                return;
            }
            if (_this.select.controller.shouldDisplayFilter() || !FilteringHandler.__isChar(ev.charCode)) {
                return;
            }
            _this.delayedResetKeypressBuffer();
            _this.filteringText += String.fromCharCode(ev.charCode);
            var matchingOptions = _this.__findKeypressMatchingOptions(_this.filteringText);
            // We have an exact match
            if (matchingOptions.length === 1) {
                _this.__handleMatch(matchingOptions[0]);
                return;
            }
            // Hit the same char over and over, we assume they want to cycle through
            if (_this.filteringText.length > 1 && FilteringHandler.__isRepeatedChar(_this.filteringText)) {
                var charMatchingOptions = _this.__findKeypressMatchingOptions(_this.filteringText[0]);
                if (charMatchingOptions.length) {
                    var active = void 0;
                    if (_this.select.__open) {
                        active = charMatchingOptions.indexOf(_this.select.__highlightedOption);
                    }
                    else {
                        // It is only SelectComponent here, Multiselect exits the method earlier,
                        // because it has enableKeypressWhenClosed=false
                        active = charMatchingOptions.indexOf(_this.select.controller.getSelectedOption());
                    }
                    // Pick the next thing (if something with this prefix wasn't selected
                    // we'll end up with the first option)
                    active += 1;
                    active = active % charMatchingOptions.length;
                    _this.__handleMatch(charMatchingOptions[active]);
                    return;
                }
            }
            // We have multiple things that start with this prefix.  Based on the
            // behavior of native select, this is considered after the repeated case
            if (matchingOptions.length) {
                _this.__handleMatch(matchingOptions[0]);
                return;
            }
            // No match at all, do nothing
        };
    };
    FilteringHandler.prototype.getFilterMatchingOptions = function () {
        var _this = this;
        var text = this.select.__filteringText;
        if (!text || this.select.filteringType === "manual" /* MANUAL */) {
            return this.select.options;
        }
        return this.select.options.reduce(function (matchingOptions, option) {
            if ('options' in option) {
                var filteredOptionsGroup = {
                    label: option.label,
                    disabled: option.disabled,
                    options: option.options.filter(function (optionToFilter) { return _this.__matchOption(optionToFilter, text, false); })
                };
                if (filteredOptionsGroup.options.length > 0) {
                    return __spreadArrays(matchingOptions, [filteredOptionsGroup]);
                }
            }
            else if (_this.__matchOption(option, text, false)) {
                return __spreadArrays(matchingOptions, [option]);
            }
            return matchingOptions;
        }, []);
    };
    FilteringHandler.prototype.__filteringInput = function () {
        var _this = this;
        return function (event) {
            event.stopPropagation();
            _this.select.__filteringText = event.detail.value;
            _this.delayedNotifyInput();
        };
    };
    return FilteringHandler;
}());
export default FilteringHandler;
//# sourceMappingURL=filtering-handler.js.map